import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const LOANS_API_URL = process.env.REACT_APP_LOANS_API_URL || buildApiUrl('/loans');

export async function fetchLoans() {
  const response = await requestLoanApi(LOANS_API_URL, {
    fallbackMessage: 'Unable to load CA records right now.',
  });

  return response.json();
}

export async function createLoan(payload) {
  const response = await requestLoanApi(LOANS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save CA record right now.',
  });

  return response.json();
}

export async function cancelLoan(id) {
  const response = await requestLoanApi(`${LOANS_API_URL}/${id}/cancel`, {
    method: 'PATCH',
    fallbackMessage: 'Unable to cancel CA record right now.',
  });

  return response.json();
}

export async function fetchSupplierDeductionHistory(supplierId) {
  const response = await requestLoanApi(
    `${LOANS_API_URL}/suppliers/${supplierId}/deductions`,
    {
      fallbackMessage: 'Unable to load CA deduction history right now.',
    }
  );

  return response.json();
}

export async function fetchLoanDeductionHistory(id) {
  const response = await requestLoanApi(`${LOANS_API_URL}/${id}/deductions`, {
    fallbackMessage: 'Unable to load CA deduction history right now.',
  });

  return response.json();
}

async function requestLoanApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
